import { useMemo } from "react";
import { Box } from "@chakra-ui/react";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";

function useContentContaParcelasColumns() {
  return useMemo(() => {
    return [
      {
        title: "Vencimento",
        render: (original: any) => (
          <Box> {moment(original.dataVencimento).format("DD/MM/YYYY")} </Box>
        ),
      },
      {
        title: "Descrição",
        dataIndex: "descricao",
      },
      {
        title: "Valor",
        render: (original: any) => <Box> {formatMoney(original.valor)} </Box>,
      },
    ];
  }, []);
}

export default useContentContaParcelasColumns;
